<template>
  <a-form :form="featureForm" class="peculiarityConfiguration">
    <a-button class="saveBtn" type="primary" :loading="btnLoading" @click="handleSubmit" v-if="$auth('deviceType.featureAdd') || $auth('deviceType.featureEdit')">保存</a-button>
    <div class="basicParameters">
      <div class="titleDiv">
        <div class="title">基本信息</div>
      </div>
      <a-row>
        <a-col :span="6">
          <a-form-item label="父节点" :label-col="labelCol2" :wrapper-col="wrapperCol2">
            <a-input
              placeholder="请输入父节点"
              autocomplete="off"
              :disabled="true"
              v-decorator="['pName',{validateTrigger: ['blur'],rules: [{ required: true, message: '请输入父节点!' }]}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="设备分类名称" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-input
              placeholder="请输入设备分类名称"
              autocomplete="off"
              v-decorator="['name',{validateTrigger: ['blur'],rules: [{ required: true, message: '请输入设备分类名称!' }]}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="分类编码" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-input
              :disabled="type === 'edit'"
              placeholder="请输入分类编码"
              autocomplete="off"
              v-decorator="['code',{validateTrigger: ['blur'],rules: [{ required: true, message: '请输入分类编码!' }]}]"
            />
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item label="是否参与统计" :label-col="labelCol" :wrapper-col="wrapperCol">
            <a-select v-decorator="['isStatistic',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择是否参与统计!' }]}]" placeholder="请选择是否参与统计">
              <a-select-option v-for="(item, index) in statisticsList" :key="index" :value="item.value">
                {{ item.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="6">
          <a-form-item label="状态" :label-col="labelCol2" :wrapper-col="wrapperCol2">
            <a-select v-decorator="['status',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择状态!' }]}]" :allowClear="true" placeholder="请选择状态">
              <a-select-option v-for="(item, index) in statusList" :key="index" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="18">
          <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              placeholder="请输入备注"
              autocomplete="off"
              v-decorator="['remark',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入备注!' }]}]"
            />
          </a-form-item>
        </a-col>
      </a-row>
    </div>
    <div class="peculiarityParameters">
      <div class="titleDiv">
        <div class="title">特性选择</div>
      </div>
      <a-row class="generalParameter">
        <a-col :span="6" v-for="(item2, index2) in peculiarityList">
          <a-form-item :labelCol="labelColAll" :wrapperCol="wrapperColAll">
            <a-tree-select
              show-search
              :filterTreeNode="filterTreeNode"
              style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择动设备参数"
              allow-clear
              tree-default-expand-all
              :treeData="peculiarityTreeList"
              v-model="item2.equipmentPeculiarityId"
              :replaceFields="{
                title: 'name',
                key: 'key',
                value: 'id'
              }"
              @change="(value, label, extra) => changeFeatureTree(value, label, extra, item2, index2)"
            ></a-tree-select>
            <a-icon type="close-square" theme="filled" class="delIcon" @click="del_speciality(item2, index2)"/>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label-col="labelColAll" :wrapper-col="wrapperColAll">
            <a-button block type="dashed" icon="plus" @click="add_speciality" class="addBtn_general">添加</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </div>
    <div class="associatedParameter">
      <div class="titleDiv">
        <div class="title">特性关联参数</div>
      </div>
      <a-row :gutter="12">
        <a-col :span="6" v-for="item in dataForm.peculiarityParamList">
          <a-input v-model="item.name" disabled></a-input>
        </a-col>
      </a-row>
    </div>
  </a-form>
</template>

<script>
import {
  addDeviceType, checkFidleDelete, checkFieldDeleteByType, checkTypeParam,
  editDeviceType,
  getDeviceTypeInfo
} from '@/api/deviceType'
import { getEquipmentTree } from '@/api/featureManagement'

export default {
  name: 'BasicModel',
  props: ['dataForm'],
  computed: {
    deviceTypeStatus () {
      return this.$store.state.deviceType.deviceTypeStatus
    }
  },
  data () {
    return {
      featureForm: this.$form.createForm(this, { name: 'featureConfiguration' }),
      labelCol: { style: 'width: 100px' },
      wrapperCol: { style: 'width: calc(100% - 100px)' },
      labelCol2: { style: 'width: 70px' },
      wrapperCol2: { style: 'width: calc(100% - 72px)' },
      spinning: false,
      btnLoading: false,
      statusList: [
        {
          id: 2,
          name: '停用'
        },
        {
          id: 1,
          name: '在用'
        }
      ],
      statisticsList: [
        {
          value: 1,
          label: '是'
        },
        {
          value: 0,
          label: '否'
        }
      ],
      peculiarityTreeList: [], // 特性树
      peculiarityList: [], // 特性
      peculiarityVerifyList: [], // 验证
      peculiarityOriginalList: [], // 原始
      peculiarityDelList: [], // 删除的特性
      labelColAll: {
        xs: { span: 24 },
        sm: { span: 0 }
      },
      wrapperColAll: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      type: 'edit',
      viewConfirmDel: false
    }
  },
  // watch: {
  //   deviceTypeStatus: {
  //     handler (newVal) {
  //       console.log(newVal)
  //       switch (newVal.type) {
  //         case 'edit':
  //           this.type = 'edit'
  //           this.getDeviceTypeInfo({ id: newVal.data.id, pName: newVal.data.pName })
  //           break
  //         case 'rootAdd':
  //           this.type = 'add'
  //           this.dataForm = {}
  //           this.initTableData(newVal.data)
  //           break
  //         case 'childAdd':
  //           this.type = 'add'
  //           this.dataForm = {}
  //           this.initTableData(newVal.data)
  //           break
  //       }
  //     },
  //     deep: true
  //   }
  // },
  created () {
    this.getFeatureTreeList()
  },
  mounted () {
  },
  methods: {
    // 获取表单数据
    async getDeviceTypeInfo (info) {
      this.$emit('setSpinning', true)
      this.spinning = true
      const res = await getDeviceTypeInfo(info.id)
      if (res.status === 0) {
        res.data.peculiarityRelevancyList.forEach((item, index) => {
          item.id = index + 1
        })
        this.dataForm = res.data
        this.initTableData({ ...res.data })
      } else {
        this.$message.error(res.info.message)
      }
      this.$emit('setSpinning', false)
    },
    // 设置表单
    initTableData (info) {
      this.setForm(info)
      this.peculiarityDelList = []
      if (this.type === 'add') {
        this.peculiarityList = []
        this.peculiarityVerifyList = []
        this.peculiarityOriginalList = []
      } else {
        this.peculiarityList = JSON.parse(JSON.stringify(info.peculiarityRelevancyList))
        this.peculiarityVerifyList = JSON.parse(JSON.stringify(info.peculiarityRelevancyList))
        this.peculiarityOriginalList = JSON.parse(JSON.stringify(info.peculiarityRelevancyList))
      }
      this.findPeculiarity()
    },
    setType (type) {
      this.type = type
    },
    // 设置表单数据
    setForm (info) {
      this.featureForm.setFieldsValue({
        pName: info.pName,
        name: info.name ? info.name : '',
        code: info.code ? info.code : '',
        isStatistic: (info.isStatistic === true || info.isStatistic === false) ? (info.isStatistic ? 1 : 0) : 1,
        status: info.status ? info.status : undefined,
        remark: info.remark ? info.remark : ''
      })
    },
    // 获取特性树
    getFeatureTreeList () {
      const data = { name: '' }
      getEquipmentTree(data).then(res => {
        if (res.status === 0) {
          this.peculiarityTreeList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 选择特性参数
    changeFeatureTree (value, label, extra, data, index) {
      const that = this
      const item = extra.triggerNode.$options.propsData.dataRef
      console.log(item)
      if (data.id) {
        console.log(data)
        this.whetherToPrompt_customize(data, index, value, 'edit', item.pid)
      } else {
        this.peculiarityList[index].equipmentPeculiarityPid = item.pid
        this.peculiarityVerifyList[index].equipmentPeculiarityPid = item.pid
      }
      this.findPeculiarity()
    },
    // 找到传入的元素，并且给他复制disabled状态
    findPeculiarity () {
      const arr = this.peculiarityList.map(item => {
        return item.equipmentPeculiarityId
      })
      function findChildren (data) {
        for (let i = 0; i < data.length; i++) {
          const j = data[i]
          if (arr.indexOf(j.id) >= 0) {
            j.disabled = true
          } else {
            j.disabled = false
          }
          if (j.children) {
            findChildren(j.children)
          }
        }
      }
      for (let i = 0; i < this.peculiarityTreeList.length; i++) {
        const j = this.peculiarityTreeList[i]
        if (arr.indexOf(j.id) >= 0) {
          j.disabled = true
        } else {
          j.disabled = false
        }
        if (j.children) {
          findChildren(j.children)
        }
      }
    },
    // 增加特性参数
    add_speciality () {
      this.peculiarityList.push({
        equipmentPeculiarityId: undefined
      })
      this.peculiarityVerifyList.push({
        equipmentPeculiarityId: undefined
      })
    },
    // 判断删除特性参数是否需要提示_自定义参数
    async whetherToPrompt_customize (item, index, value, type, pid) {
      console.log('item', item)
      const params1 = {
        dataIndex: type === 'edit' ? this.peculiarityVerifyList[index].equipmentPeculiarityId : item.equipmentPeculiarityId,
        type: 4,
        typeCode: this.deviceTypeStatus.data.code
      }
      console.log(params1)
      const that = this
      await checkFieldDeleteByType(params1).then(res => {
        if (res.status === 0) {
          if (res.data) {
            if (type === 'edit') {
              this.$message.error('该参数已被使用，无法修改')
              that.peculiarityList[index].equipmentPeculiarityId = that.peculiarityVerifyList[index].equipmentPeculiarityId
              that.peculiarityList[index].equipmentPeculiarityPid = that.peculiarityVerifyList[index].equipmentPeculiarityPid
              that.findPeculiarity()
            } else {
              this.$message.error('该参数已被使用，无法删除')
            }
          } else {
            if (type === 'edit') {
              this.$confirm({
                title: '特性变更后，原特性的关联的参数保留到常规参数关联，是否继续操作？',
                okText: '继续',
                okType: 'danger',
                cancelText: '取消',
                onOk () {
                  that.peculiarityVerifyList[index].equipmentPeculiarityId = value
                  that.peculiarityVerifyList[index].equipmentPeculiarityPid = pid
                  that.peculiarityList[index].equipmentPeculiarityPid = pid
                  that.findPeculiarity()
                },
                onCancel () {
                  that.peculiarityList[index].equipmentPeculiarityId = that.peculiarityVerifyList[index].equipmentPeculiarityId
                  that.peculiarityList[index].equipmentPeculiarityPid = that.peculiarityVerifyList[index].equipmentPeculiarityPid
                  that.findPeculiarity()
                }
              })
            } else {
              this.showDeleteConfirm(item, index)
            }
          }
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    },
    // 判断删除特性参数
    del_speciality (item, index) {
      if (item.id) {
        this.whetherToPrompt_customize(item, index)
        // this.showDeleteConfirm(item, index)
      } else {
        this.peculiarityList.splice(index, 1)
        this.peculiarityVerifyList.splice(index, 1)
        this.findPeculiarity()
      }
    },
    // 删除特性参数
    delPeculiarity (item, index) {
      // const delData = { ...item }
      // delData.status = 9
      // this.peculiarityDelList.push(delData)
      this.peculiarityList.splice(index, 1)
      this.peculiarityVerifyList.splice(index, 1)
      this.findPeculiarity()
    },
    // 删除二次确认
    showDeleteConfirm (item, index) {
      const that = this
      this.$confirm({
        title: '去除该特性后，特性对应的参数仍然保留，确定是否要去除特性？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          that.delPeculiarity(item, index)
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    },
    // 参数树搜索
    filterTreeNode (inputValue, treeNode) {
      return treeNode.componentOptions.propsData.dataRef.name.indexOf(inputValue.toLowerCase()) > -1
    },
    // 参数设置保存
    handleSubmit () {
      this.featureForm.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          const peculiarityRelevancyList = []
          try {
            this.peculiarityList.forEach(item => {
              if (item.equipmentPeculiarityId) {
                const data = {
                  'equipmentTypeId': this.deviceTypeStatus.data.id,
                  'equipmentPeculiarityId': item.equipmentPeculiarityId,
                  'equipmentTypeCode': this.deviceTypeStatus.data.code,
                  'equipmentPeculiarityPid': item.equipmentPeculiarityPid,
                  'status': item.status ? item.status : 1
                }
                peculiarityRelevancyList.push(data)
              } else {
                throw new Error('')
              }
            })
          } catch (error) {
            this.$message.error('特性参数不能为空')
            this.btnLoading = false
            return
          }
          const params = {
            pid: this.deviceTypeStatus.data.pid,
            name: value.name,
            code: value.code,
            status: value.status,
            isStatistic: value.isStatistic,
            remark: value.remark,
            peculiarityRelevancyList: peculiarityRelevancyList
          }
          this.btnLoading = true
          if (this.type === 'add') {
            addDeviceType(params).then(res => {
              if (res.status === 0) {
                this.type = 'edit'
                this.$message.success(res.info.message)
                this.$emit('getTabData', {
                  id: res.data,
                  typeId: res.data,
                  typeCode: value.code,
                  type: 'edit'
                })
                this.deviceTypeStatus.data.id = res.data
                this.deviceTypeStatus.data.code = value.code
                this.$emit('refreshTreeParent', res)
                this.btnLoading = false
              } else {
                this.$message.error(res.info.message)
                this.btnLoading = false
              }
            }).catch(err => {
              this.$message.error(err.info.message)
              this.btnLoading = false
            })
          }
          if (this.type === 'edit') {
            params.id = this.deviceTypeStatus.data.id
            editDeviceType(params).then(res => {
              if (res.status === 0) {
                this.$message.success(res.info.message)
                this.$emit('getTabData', {
                  id: res.data,
                  typeId: res.data,
                  typeCode: this.deviceTypeStatus.data.code
                })
                this.$emit('refreshTreeParent', res)
                this.btnLoading = false
              } else {
                this.$message.error(res.info.message)
                this.btnLoading = false
              }
            }).catch(err => {
              this.$message.error(err.info.message)
              this.btnLoading = false
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">

.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  .title{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: #08409F;
  }
}
.peculiarityConfiguration {
  height: calc(100% - 45px);
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid #DDDDDD;
  padding-top: 11px;
  .saveBtn {
    margin-bottom: 12px;
  }
  .associatedParameter {
    margin-top: 8px;
    border-top: 1px solid #DDDDDD;
    padding-top: 11px;
  }
}
.generalParameter {
  /deep/.ant-col-6 {
    padding-right: 12px;
    .ant-form-item-children {
      display: flex;
      flex-direction: row;
      align-items: center;
      .ant-select {
        width: calc(100% - 28px);
        margin-right: 8px;
      }
      .delIcon {
        font-size: 20px;
        color: red;
      }
    }
  }
}
.addBtn_general {
  width: 100%;
  /deep/.anticon {
    color: #1791FF;
  }
}
</style>
